import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-credit-causes',
  templateUrl: './order-line-credit-causes.component.html',
  styleUrls: ['./order-line-credit-causes.component.css']
})
export class OrderLineCreditCausesComponent implements OnInit {
    public itemsListCauses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadOrderLineCreditCauses(): Promise<void> {
        this.itemsListCauses = await this.datatask.Post(2762);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'orderlinecreditcause':
                this.stateService?.go('orderlinecreditcause', { orderlinecreditcause_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadOrderLineCreditCauses();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCreditCauses', {
//        templateUrl: 'views/components/views/orderLineCreditCauses/orderLineCreditCauses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'orderLineCreditCausesService', function (stateService, orderLineCreditCausesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCauses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadOrderLineCreditCauses() {
//                vm.model.itemsListCauses = await orderLineCreditCausesService.listOrderLineCreditCauses();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'orderlinecreditcause':
//                        go({ orderlinecreditcause_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadOrderLineCreditCauses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
